import { CountingLineEventTypes, IntervalZoneEventTypes } from "./analysis";
import { Coordinate } from "./shape";

export type BranchResponse = {
  uid: string;
  name: string;
  client: {
    uid: string;
    name: string;
  };
  branch_config: {
    status: 0 | 1 | 2;
  };
  camera_orientation_count: number;
  counting_line_count: number;
  interval_zone_count: number;
};

export type BranchVersionResponse = {
  id: number;
  branch_uid: string;
  name: string;
  description: string;
  created_at: number;
  valid_from?: string;
  valid_until?: string;
  is_active: boolean;
};

export type CameraMemoResponse = {
  id: number;
  type: CameraMemoTypeResponse;
  floor_plan_id: number | null;
  // kenny: 단수인데 api에서 coordinates라는 필드명으로 보내줘서 그대로 사용
  floor_plan_coordinates: Coordinate | null;
  analyzed_coordinates: Coordinate | null;
  content: string;
  pseudo_camera_orientation_id: number;
  updated_at: number;
  user: UserResponse | null;
};

export enum CameraMemoTypeResponse {
  Default = 0,
  Adjustment = 1,
}

export type CameraResponse = {
  id: number;
  pseudo_camera: {
    id: number;
    default_cam_id: string;
    branch_uid: string;
  };
  preview_img_url?: string;
  original_img_url?: string;
  analyzed_id: string | null;
  floor_plan_id: number | null;
  position: {
    x: number;
    y: number;
    rotation: number;
  } | null;
  extra_camera_orientation_status: {
    extra_id: string;
  } | null;
  adjustment_status: {
    adjustment_id: string;
    position: {
      x: number;
      y: number;
      rotation: number;
    };
    frame: {
      dx: number;
      dy: number;
    };
  } | null;
};

export type CountingLineResponse = {
  id: number;
  key: string;
  analysis_setting_status: {
    name: string;
    event_type: CountingLineEventTypes;
    coordinates: Coordinate[];
  } | null;
  floor_plan_status: {
    coordinates: Coordinate[];
  } | null;
  pseudo_camera_orientation_id: number;
};

export type FloorPlanMemoDiagramResponse = {
  id: number;
  floor_plan_id: number;
  style: {
    fill?: string;
    border_color?: string;
    opacity: number;
  };
  coordinates: Coordinate[];
};

export type FloorPlanResponse = {
  id: number;
  version_id: number;
  name: string;
  img_url: string;
  icon_size: number;
  floor_number: number;
};

export type FloorPlanMemoTextResponse = {
  id: number;
  floor_plan_id: number;
  content: string;
  style: {
    color: string;
    width: number;
    opacity: number;
    font_size: number;
    has_stroke: boolean;
    rotation?: number;
  };
  position: {
    x: number;
    y: number;
  };
};

export type IntervalZoneResponse = {
  id: number;
  key: string;
  analysis_setting_status: {
    name: string;
    event_type: IntervalZoneEventTypes;
    coordinates: Coordinate[];
  } | null;
  floor_plan_status: {
    coordinates: Coordinate[];
  } | null;
  pseudo_camera_orientation_id: number;
};

export type PseudoCameraResponse = {
  id: number;
  default_cam_id: string;
  branch_uid: string;
};

export type UserResponse = {
  email: string;
  name: string;
  is_staff: boolean;
  client: {
    uid: string;
    name: string;
  };
};
